<script setup>
import BaseContentCard from '@/components/cards/baseContentCard/BaseContentCard.vue';
import BaseContent from '@/components/cards/baseContentCard/BaseContent.vue';
import CardInfo from '@/components/cards/CardInfo.vue';

defineProps({
  imgSrc: {
    type: String,
    required: true,
  },
  shouldShowDate: {
    type: Boolean,
    default: true,
  },
  shouldShowInfoTag: {
    type: Boolean,
    default: true,
  },
  shouldShowMediaCount: {
    type: Boolean,
    default: false,
  },
  picturesCount: {
    type: Number,
    required: false,
  },
  videosCount: {
    type: Number,
    required: false,
  },
  mediaCount: {
    type: Number,
    required: false,
  },
  title: {
    type: String,
    required: true,
  },
  date: {
    type: String,
    required: false,
  },
  backgroundColor: {
    type: String,
    required: true,
    default: 'red',
  },
  isCancelled: {
    type: Boolean,
    required: false,
    default: false,
  },
  isToday: {
    type: Boolean,
    required: false,
    default: false,
  },
  isNow: {
    type: Boolean,
    required: true,
  },
  item: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <div class="relative">
    <!-- Opacity overlay -->
    <div
      v-if="isCancelled"
      class="absolute inset-0 bg-neutral-100 opacity-40 z-10"
    />

    <CardInfo :item="item" :shouldShowDate="shouldShowDate" />

    <BaseContentCard :backgroundColor="backgroundColor" :imgSrc="imgSrc">
      <template v-slot:footer>
        <BaseContent
          :date="date"
          :title="title"
          :picturesCount="picturesCount"
          :videosCount="videosCount"
          :mediaCount="mediaCount"
          :shouldShowMediaCount="shouldShowMediaCount"
          :shouldShowDate="shouldShowDate"
        />
      </template>
    </BaseContentCard>
  </div>
</template>
